export default function LineFunction() {
    this.omiseLib = window.Omise;

    /**
     * @param {string} publicKey from main/cart_config
     */
    this.init = function(publicKey) {
        this.omiseLib.setPublicKey(publicKey);
    }
    /**
     * @param {object} cardParam from CreditCardModel getParams()
     */
    this.getToken = function(cardParam) {
        return new Promise((resolve, reject) => {
            try {
                this.omiseLib.createToken("card",cardParam, (statusCode, response) => {
                    resolve(response);
                }, (err) => {
                    reject(err);
                });
            } catch (e) {
                reject(e);
            }
        });
    }
}